import {
	type BrowserHawk,
	captureEarlyErrors,
	createBrowserHawk,
	type HawkBrowserApp,
} from "@iec-id/shared/observability/hawk-browser";

/**
 * Трекер ошибок Hawk. Инициализируется первым делом в `main.tsx` — раньше
 * роутера и провайдеров, иначе падения bootstrap'а остались бы невидимыми.
 *
 * Пользователь уезжает в Hawk исключительно как необратимый хэш `users.id`.
 *
 * `||`, а не `??`: Dockerfile выставляет `ENV VITE_HAWK_TOKEN=` пустой
 * строкой, и `??` принял бы её за заданный токен.
 */
const IS_ENABLED = import.meta.env.PROD || import.meta.env.VITE_HAWK_DEBUG === "true";

let hawk: BrowserHawk | null = null;
const pending: Array<(target: BrowserHawk) => void> = [];

export async function initHawk(app: HawkBrowserApp): Promise<void> {
	if (hawk || !IS_ENABLED) return;

	const collectEarly = captureEarlyErrors();

	hawk = await createBrowserHawk({
		token: import.meta.env.VITE_HAWK_TOKEN || undefined,
		app,
		release: __HAWK_RELEASE__,
		context: {
			platform:
				typeof navigator !== "undefined" && /Mobi|Android/i.test(navigator.userAgent)
					? "mobile-web"
					: "desktop-web",
		},
	});

	const early = collectEarly();
	if (!hawk) return;

	for (const item of early) hawk.send(item.error, item.context);
	for (const action of pending.splice(0)) action(hawk);
}

export function reportError(error: Error | string, context?: Record<string, unknown>): void {
	if (hawk) {
		hawk.send(error, context);
		return;
	}
	if (IS_ENABLED) pending.push((target) => target.send(error, context));
}

export function setHawkUser(userId: string): void {
	if (hawk) {
		hawk.setUser(userId);
		return;
	}
	if (IS_ENABLED) pending.push((target) => target.setUser(userId));
}

export function clearHawkUser(): void {
	if (hawk) {
		hawk.clearUser();
		return;
	}
	if (IS_ENABLED) pending.push((target) => target.clearUser());
}
